<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
  <mat-label>Search Page (Ctrl + M)</mat-label>
  <input
    #searchInput
    type="text"
    matInput
    [formControl]="searchControl"
    [matAutocomplete]="auto"
    placeholder="Type to search pages..." />

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onPageSelect($event.option.value)">

    <ng-container *ngFor="let group of (groupedOptions$ | async)">
      <mat-optgroup [label]="group.group">
        <mat-option *ngFor="let page of group.pages" [value]="page">
          {{ page.label }}
        </mat-option>
      </mat-optgroup>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
